/* Model pricing — usage is expressed in credits instead of plan cards. */

import type { PricingContent } from "../i18n/types";

interface ModelRate {
  model: string;
  logo: string;
  logoAlt: string;
  developer: string;
  context: string;
  input: string;
  output: string;
  cached: string;
}

const MODEL_RATES: ModelRate[] = [
  { model: "GLM 5.3", logo: "/assets/model-logos/zai.png", logoAlt: "Z.ai", developer: "Z.ai · open weights", context: "1M", input: "5.815", output: "17.362", cached: "1.163" },
  { model: "GLM 5.3-Flash", logo: "/assets/model-logos/zai.png", logoAlt: "Z.ai", developer: "Z.ai · open weights", context: "1M", input: "0.753", output: "2.832", cached: "0.151" },
];

export function renderPricing(t: PricingContent): HTMLElement {
  const root = document.createElement("section");
  root.className = "section pricing";
  root.id = "models";
  root.innerHTML = `
    <div class="page">
      <div class="section-head section-head--center" data-reveal>
        <h2 class="section__title">${t.title}</h2>
        <p class="section__lead">
          ${t.lead}
        </p>
      </div>
      <div class="pricing-table-wrap" data-reveal style="--reveal-delay:80ms">
        <table class="pricing-table">
          <thead>
            <tr>
              ${t.tableHeaders.map((h) => `<th scope="col">${h}</th>`).join("")}
            </tr>
          </thead>
          <tbody>
            ${MODEL_RATES.map((rate, i) => `
              <tr>
                <th scope="row" data-label="${t.tableHeaders[0]}">
                  <span class="pricing-table__model">
                    <img src="${rate.logo}" alt="${rate.logoAlt}" width="24" height="24" />
                    <span class="pricing-table__modelMeta">
                      <span class="pricing-table__modelName">${rate.model}</span>
                      <span class="pricing-table__dev">${rate.developer}</span>
                    </span>
                  </span>
                </th>
                <td data-label="${t.tableHeaders[1]}" class="pricing-table__bestfor">${t.models[i].bestFor}</td>
                <td data-label="${t.tableHeaders[2]}" class="mono">${rate.context}</td>
                <td data-label="${t.tableHeaders[3]}" class="pricing-table__credit">${rate.input}</td>
                <td data-label="${t.tableHeaders[4]}" class="pricing-table__credit">${rate.output}</td>
                <td data-label="${t.tableHeaders[5]}" class="pricing-table__credit">${rate.cached}</td>
              </tr>
            `).join("")}
          </tbody>
        </table>
      </div>
      <p class="pricing__note">${t.note}</p>
    </div>
  `;
  return root;
}
